import React from 'react';
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig';

export const publicRoutes = [
  {
    key: 'login',
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import('views/auth-views/authentication/login')
    ),
  },
  {
    key: 'forgot-password',
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import('views/auth-views/authentication/forgot-password')
    ),
  },
];

export const protectedRoutes = [
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/`,
    component: React.lazy(() => import('views/app-views/dashboards/default')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/admins`,
    component: React.lazy(() => import('views/app-views/admin')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/users`,
    component: React.lazy(() => import('views/app-views/user')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/warranties`,
    component: React.lazy(() => import('views/app-views/warranty')),
  },
  {
    key: 'warranties.claims',
    path: `${APP_PREFIX_PATH}/warranties/claims`,
    component: React.lazy(
      () => import('views/app-views/warranty/claims/index')
    ),
  },
  {
    key: 'voucher.campaign-management',
    path: `${APP_PREFIX_PATH}/voucher/campaign-management`,
    component: React.lazy(
      () => import('views/app-views/voucher/campaign-management/index')
    ),
  },
  {
    key: 'voucher.redemption-history',
    path: `${APP_PREFIX_PATH}/voucher/redemption-history`,
    component: React.lazy(
      () => import('views/app-views/voucher/redemption-history/index')
    ),
  },
  {
    key: 'voucher.redeem-list',
    path: `${APP_PREFIX_PATH}/voucher/redeem-list`,
    component: React.lazy(
      () => import('views/app-views/voucher/redeem-list/index')
    ),
  },
  {
    key: 'voucher.voucher-registration',
    path: `${APP_PREFIX_PATH}/voucher/voucher-registration`,
    component: React.lazy(
      () => import('views/app-views/voucher/voucher-registration/index')
    ),
  },
  {
    key: 'voucher.sms-notification',
    path: `${APP_PREFIX_PATH}/voucher/sms-notification`,
    component: React.lazy(
      () => import('views/app-views/voucher/sms-notification/index')
    ),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/dealers`,
    component: React.lazy(() => import('views/app-views/dealer')),
  },
  {
    key: 'sales',
    path: `${APP_PREFIX_PATH}/sales`,
    component: React.lazy(() => import('views/app-views/sales')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/products`,
    component: React.lazy(() => import('views/app-views/product')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/news`,
    component: React.lazy(() => import('views/app-views/news')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/messages`,
    component: React.lazy(() => import('views/app-views/messages')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/logs`,
    component: React.lazy(() => import('views/app-views/warrantylogs')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/reset`,
    component: React.lazy(() => import('views/app-views/reset')),
  },
  {
    key: 'dashboard.default',
    path: `${APP_PREFIX_PATH}/tyres`,
    component: React.lazy(() => import('views/app-views/tyre-pattern')),
  },
  {
    key: 'incentive.rewards',
    path: `${APP_PREFIX_PATH}/incentive-rewards`,
    component: React.lazy(
      () => import('views/app-views/incentive/incentive-rewards')
    ),
  },
  // {
  //   key: 'incentive.reports',
  //   path: `${APP_PREFIX_PATH}/incentive-reports`,
  //   component: React.lazy(() => import('views/app-views/incentive/incentive-reports')),
  // },
  {
    key: 'incentive.reward.dealers',
    path: `${APP_PREFIX_PATH}/incentive-rewards/:id/dealers`,
    component: React.lazy(
      () => import('views/app-views/incentive/incentive-reward-dealers')
    ),
  },
  {
    key: 'incentive.reports.sender',
    path: `${APP_PREFIX_PATH}/incentive-reports-sender`,
    component: React.lazy(
      () => import('views/app-views/incentive/incentive-reports-sender')
    ),
  },
  {
    key: 'incentive.promotions',
    path: `${APP_PREFIX_PATH}/incentive-promotions`,
    component: React.lazy(
      () => import('views/app-views/incentive/incentive-promotions')
    ),
  },
  {
    key: 'incentive.reports.new',
    path: `${APP_PREFIX_PATH}/incentive-reports-new`,
    component: React.lazy(
      () => import('views/app-views/incentive/incentive-reports-new')
    ),
  },
  {
    key: 'dealer.wallet',
    path: `${APP_PREFIX_PATH}/dealer-wallet`,
    component: React.lazy(() => import('views/app-views/dealer-wallet')),
  },
];
